"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineEditTrigger = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = require("../../elements/button/Button");
var _react = _interopRequireDefault(require("react"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var _editSmall = require("../../assets/icons/edit-small.svg");
var _inlineEditTriggerModule = _interopRequireDefault(require("./inline-edit-trigger.module.scss"));
var InlineEditTrigger = function InlineEditTrigger(_ref) {
  var children = _ref.children,
    className = _ref.className,
    enabled = _ref.enabled,
    onClick = _ref.onClick,
    variant = _ref.variant,
    label = _ref.label,
    testId = _ref['data-testid'];
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_inlineEditTriggerModule.default['inline-edit-trigger'], className)
  }, children, enabled && /*#__PURE__*/_react.default.createElement(_Button.LinkButton, {
    "data-testid": testId,
    className: (0, _classnames.default)(_inlineEditTriggerModule.default['inline-edit-trigger__edit-button'], (0, _defineProperty2.default)({}, _inlineEditTriggerModule.default['inline-edit-trigger__edit-button--big'], variant === 'big')),
    inline: true,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_editSmall.ReactComponent, {
    "data-testid": testId && "".concat(testId, "-edit-icon"),
    className: (0, _classnames.default)(_inlineEditTriggerModule.default['inline-edit-trigger__edit-icon'], (0, _defineProperty2.default)({}, _inlineEditTriggerModule.default['inline-edit-trigger__edit-icon--big'], variant === 'big'))
  }), label || t('inlineEditTrigger.edit')));
};
exports.InlineEditTrigger = InlineEditTrigger;